const NETWORK_CONSTANTS = {
  // BASE_URL: 'http://localhost:8000',
  // Uncomment code below if you'd like to point your FE code to the development server
  BASE_URL: 'https://api.blueearthdxmedicalaffairshub.com',

  API_LOGIN: '/auth/login/',
  API_FORGOT_PASSWORD: '/auth/forgot-password/',
  API_SET_PASSWORD: '/auth/set-password/',
  API_REGISTER: '/auth/register/',
  API_SELF_REGISTER: '/auth/self-register/',
  API_INVITE_USER: '/auth/invite-user/',

  API_DOWNLOAD_ZIP: '/api/zip/',
  API_ADMIN_PERMISSIONS: '/api/admin-permissions/',
  API_ADMIN_PERMISSIONS_AUDIT: '/api/admin-permissions/audit/',

  API_USERS: '/api/users/',
  API_TRAININGS: '/api/user-trainings/',
  API_KNOWLEDGE_CHECK: '/api/knowledge-check',
  API_ANSWERS: '/api/answers',

  API_ROLES: '/api/roles/',
  API_STATES: '/api/state/',
  API_GROUPS: '/api/groups/',
  API_STATUSES: '/api/status/',

  API_DICOM: '/api/dicom/',
};

export default NETWORK_CONSTANTS;
